'use client';

import type { NavigationMenuDocument } from '@/modules/sanity-studio/types';
import { Navbar } from '../../composites';
import { useNavbar } from '../../../application/hooks';

type NavbarContainerProps = {
	navigationMenu: NavigationMenuDocument;
};

const NavbarContainer = ({ navigationMenu }: NavbarContainerProps) => {
	const {
		isAuth,
		handleGoToLogin,
		handleGoToAccount,
		handleGoToCart,
		cartItems,
	} = useNavbar();

	const isEmpty = cartItems === undefined || cartItems.length === 0;

	return (
		<Navbar
			isAuth={isAuth}
			isEmpty={isEmpty}
			navigationMenu={navigationMenu}
			onClickAccount={isAuth ? handleGoToAccount : handleGoToLogin}
			onClickCart={handleGoToCart}
		/>
	);
};

export default NavbarContainer;